export default __webpack_public_path__ + "static/media/jeep.8ee43238.svg";